import { useState } from "react";
import { Company } from "../../types/schema";
import "../../css/UserEditModal.css";
import "../../css/SiteAdminModals.css";

interface ArchiveModalProps {
    isOpen: boolean;
    onClose: () => void;
    company: Company | null;
    userCount: number;
    equipmentCount: number;
    monthlyRevenue: number;
    onArchive: () => void;
}

export const ArchiveModal = ({ isOpen, onClose, company, userCount, equipmentCount, monthlyRevenue, onArchive }: ArchiveModalProps) => {
    const [confirmed, setConfirmed] = useState(false);

    if (!isOpen || !company) return null;

    const handleClose = () => { setConfirmed(false); onClose(); };

    return (
        <div className="uem-overlay" onClick={handleClose}>
            <div className="uem-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 480 }}>
                <div className="uem-header">
                    <h2 style={{ color: "#c0392b" }}>Archive Company</h2>
                    <button className="uem-close" onClick={handleClose} aria-label="Close">×</button>
                </div>
                <div className="uem-body">
                    <div className="uem-warning-banner" style={{ background: "#fff3e0", borderColor: "#ffe0b2", color: "#8b5e00" }}>
                        <span className="uem-warning-icon">⚠</span>
                        <span>Archiving will suspend this account. All data is preserved but the company will no longer be counted for billing. Users will lose access until reactivated.</span>
                    </div>
                    <div style={{ background: "#f7f9fb", borderRadius: 10, padding: "16px 18px", margin: "16px 0" }}>
                        <div style={{ fontWeight: 700, color: "var(--navy-blue)", fontSize: "0.9rem" }}>{company.name}</div>
                        <div style={{ fontSize: "0.78rem", color: "var(--slate-gray)", marginTop: 4 }}>
                            {userCount} users · {equipmentCount} equipment · ${monthlyRevenue.toFixed(2)}/mo revenue
                        </div>
                    </div>
                    <div className="uem-confirm-row">
                        <input type="checkbox" checked={confirmed} onChange={(e) => setConfirmed(e.target.checked)} id="archive-confirm" />
                        <label className="uem-confirm-text" htmlFor="archive-confirm">
                            I understand this will suspend access for all users at <strong>{company.name}</strong> and remove them from billing.
                        </label>
                    </div>
                </div>
                <div className="uem-footer">
                    <button type="button" className="uem-btn-cancel" onClick={handleClose}>Cancel</button>
                    <button type="button" className="uem-btn-submit" style={{ background: "#c0392b" }} disabled={!confirmed} onClick={() => { onArchive(); setConfirmed(false); }}>
                        Archive Account
                    </button>
                </div>
            </div>
        </div>
    );
};
